import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'


import { PaymentExemption } from './PaymentExemption'
import { ExpenseExemption } from './ExpenseExemption'
import { LegalizationPayment } from './LegalizationPayment'

export const ModalModule = ({ useFetchInit, access }) => {
    
    const { dataModal, toggle } = useFetchInit

    const { open, titleModal, componentModal, dataRequest } = dataModal
    // const { CONTENEDOR, NUMERO_BL, BOOKING, TYPE } = (dataRequest && dataRequest.data) || {}

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggle}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <IconButton aria-label='close' onClick={toggle}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    {componentModal === 'PaymentExemption' && (
                        <PaymentExemption useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                    
                    {componentModal === 'ExpenseExemption' && (
                        <ExpenseExemption useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                    
                    {componentModal === 'LegalizationPayment' && (
                        <LegalizationPayment useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                    
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}